import { Breakpoint, breakpointEnding } from '@unbounded/unbounded-components'

export const headerHeight = 64
export const headerMobileBreakpoint = breakpointEnding(Breakpoint.md)
